import { render } from "./CathayFlexDeck.vue?vue&type=template&id=06b7478d"
import script from "./CathayFlexDeck.vue?vue&type=script&lang=js"
export * from "./CathayFlexDeck.vue?vue&type=script&lang=js"

import "./CathayFlexDeck.vue?vue&type=style&index=0&id=06b7478d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__